import { Button } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import redux, { RootState } from '../../redux';

const sx = () => ({
  '&:disabled': {
    backgroundColor: '#67A1F4',
    color: '#FFF',
  },
  '&:hover': {
    backgroundColor: '#003AE7',
    color: '#FFF',
  },
  backgroundColor: '#1C5BFE',
  border: '0 none',
  borderRadius: '8px',
  color: '#FFF',
  fontFamily: 'Avenir Next',
  fontSize: 14,
  fontWeight: 600,
  gap: '10px',
  height: 35,
  padding: '8px 16px',
  textTransform: 'none',
});

function BulkPauseUnpauseSendButton() {
  const { t } = useTranslation('bulkPauseUnpause');
  const dispatch: typeof redux.store.dispatch = useDispatch();
  const reason = useSelector(
    (state: RootState) => state.bulkPauseUnpause.reason,
  );
  const action = useSelector(
    (state: RootState) => state.bulkPauseUnpause.action,
  );

  const pauseUnpauseMachines = () => {
    dispatch(redux.modal.close());
    dispatch(redux.api.pauseUnpauseMachineRequest());
  };

  return (
    <Button
      disabled={action === 'pause' && reason === ''}
      onClick={pauseUnpauseMachines}
      sx={sx}
    >
      {t('save')}
    </Button>
  );
}

export default BulkPauseUnpauseSendButton;
